import ApplicationLayout from 'components/layouts/ApplicationLayout';
import { useParams, Redirect } from 'react-router-dom';
import {
  TextField,
  Typography,
  Paper,
  Grid,
  MenuItem,
  Box,
  Switch,
  FormControlLabel,
  Button,
  CircularProgress,
} from '@material-ui/core';
import Breadcrumbs from 'components/Breadcrumbs';
import { getRoleOptions } from 'store/user';
import { useState, useEffect } from 'react';
import _ from 'lodash';
import { updateUser, getUserById } from 'api/cms/user';
import { toast } from 'react-toastify';

const UserManagement = () => {
  const { user_id } = useParams();
  const [currentData, setCurrentData] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const roleOptions = getRoleOptions();

  useEffect(() => {
    setIsLoading(true);
    getUserById(user_id)
      .then((res) => {
        setCurrentData(res);
        setData(res);
      })
      .catch(() => {
        setData({});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [user_id]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = () => {
    const changedFields = _.pickBy(data, (value, key) => value !== currentData[key]);

    if (_.isEmpty(changedFields)) {
      toast.error('No changes detected');
      return;
    }

    setIsLoading(true);
    updateUser(data.user_id, changedFields)
      .then((response) => {
        toast.success('Updated successfully');
        history.replace({
          pathname: location.pathname,
          state: { data: { ...data, ...changedFields } },
        });
      })
      .catch((error) => {
        toast.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!data) {
    return <Redirect to="/admin/user_list" />;
  }

  return (
    <ApplicationLayout>
      <Breadcrumbs breadcrumbNameAddOn={{ [`${location.pathname}`]: data?.platform_name }} />
      <Paper style={{ padding: 24 }}>
        <Box display="flex" alignItems="center" mb={3}>
          <Typography variant="h6" gutterBottom>
            User Management ({data.platform_name})
          </Typography>

          <Box flexGrow={1} display="flex" justifyContent="center">
            <FormControlLabel
              control={<Switch color="secondary" />}
              label="Enable 2 Factor Authentication"
              labelPlacement="end"
            />
          </Box>

          <FormControlLabel
            control={
              <Switch
                color="secondary"
                checked={data.is_active || false}
                onChange={(e) => setData({ ...data, is_active: e.target.checked })}
              />
            }
            label="Active"
            labelPlacement="end"
          />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Username"
              variant="outlined"
              size="small"
              fullWidth
              value={data.username || ''}
              name="username"
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Platform Code"
              variant="outlined"
              size="small"
              fullWidth
              value={data.platform_code || ''}
              name="platform_code"
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Platform Name"
              variant="outlined"
              size="small"
              fullWidth
              value={data.platform_name || ''}
              name="platform_name"
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Password"
              variant="outlined"
              size="small"
              fullWidth
              type="password"
              value={data.password || ''}
              onChange={handleFieldChange}
              name="password"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Contact Person"
              variant="outlined"
              size="small"
              fullWidth
              value={data.contact_person || ''}
              onChange={handleFieldChange}
              name="contact_person"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Merchant Code"
              variant="outlined"
              size="small"
              fullWidth
              value={data.merchant_code || ''}
              onChange={handleFieldChange}
              name="merchant_code"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Email"
              variant="outlined"
              size="small"
              fullWidth
              value={data.email || ''}
              onChange={handleFieldChange}
              name="email"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Domain"
              variant="outlined"
              size="small"
              fullWidth
              value={data.domain || ''}
              onChange={handleFieldChange}
              name="domain"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Role"
              variant="outlined"
              size="small"
              fullWidth
              select
              value={data.role || ''}
              onChange={(e) => setData({ ...data, role: e.target.value })}
            >
              {roleOptions.map((role) => (
                <MenuItem key={role.value} value={role.value}>
                  {role.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Grid container item justifyContent="flex-end">
          <Grid style={{ marginTop: 24 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Save'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </ApplicationLayout>
  );
};

export default UserManagement;
